import { aiToolDateTimeSchema } from '@erikdakoda/ai-tool/aiToolDateTimeSchema';
import { z } from 'zod';

/** One option inside a prompt variable definition. */
export const promptVariableOptionForAiToolsSchema = z.object({
  value: z.string(),
  label: z.string().nullable().optional(),
});

/** Prompt variable definition stored as JSON on the Prompt model. */
export const promptVariableForAiToolsSchema = z.object({
  name: z.string(),
  label: z.string().nullable().optional(),
  default: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  options: z.array(promptVariableOptionForAiToolsSchema).nullable().optional(),
});

/** Scalar / leaf fields for a prompt (no nested childPrompts). */
export const promptForAiToolsBaseSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  createdAt: aiToolDateTimeSchema,
  updatedAt: aiToolDateTimeSchema,
  publishedAt: aiToolDateTimeSchema.nullable().optional(),
  private: z.boolean(),
  ownerId: z.string(),
  spaceId: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  group: z.string().nullable().optional(),
  handle: z.string().nullable().optional(),
  variables: z.array(promptVariableForAiToolsSchema).optional(),
  script: z.string().nullable().optional(),
  text: z.string(),
});

export const promptChildRowSchema = z.lazy(() =>
  z.object({
    id: z.string(),
    ord: z.number().nullable().optional(),
    parentPromptId: z.string().nullable().optional(),
    parentBotId: z.string().nullable().optional(),
    values: z.record(z.string(), z.string()).nullable().optional(),
    promptId: z.string().optional(),
    prompt: PromptForAiToolsSchema,
  }),
);

/**
 * Canonical Zod shape for a Prompt in AI tools (`id` included).
 * Nested `childPrompts` matches read/edit payloads from the ORM.
 */
export const PromptForAiToolsSchema = promptForAiToolsBaseSchema.extend({
  childPrompts: z.array(promptChildRowSchema).nullable().optional(),
});

export type PromptForAiTools = z.infer<typeof PromptForAiToolsSchema>;

export type PromptChildLinkForAiTools = NonNullable<PromptForAiTools['childPrompts']>[number];
